// extracted by mini-css-extract-plugin
module.exports = {"root":"_6a7b25d","card":"_3098db5","info":"_a5bc6c3"};